import { keepPreviousData, useQuery } from "@tanstack/react-query";

import {
  ProductSearchParams,
  searchProducts,
} from "../../services/productPlaneApi";
import { queryKeys } from "./keys";

/**
 * TanStack Query hook for the product search.
 *
 * The caller builds the request. Uses `keepPreviousData` so the previous
 * page stays visible while the next one loads.
 */
export function useProductSearch(params: ProductSearchParams, enabled = true) {
  return useQuery({
    queryKey: queryKeys.productPlane.search(params),
    queryFn: () => searchProducts(params),
    enabled,
    staleTime: 60 * 1000,
    gcTime: 5 * 60 * 1000,
    placeholderData: keepPreviousData,
  });
}
